import React, { ReactNode, useEffect } from "react";
import LoginSideImage from "./../assects/img/login_side_pic.png"
import { useNavigate } from "react-router-dom";
import Alert from "../components/Alert";
import { loginCheck } from "../services/apiService";
import XoroBlack from "./../assects/img/XORO-Black-1080 (5).png"
import XoroWhite from "./../assects/img/XORO-White-1080 (4).png"

interface LoginLayoutProps {
    children: ReactNode;
    isError: boolean;
    error: string | null;
    setIsError: any;
  }

const LoginLayout: React.FC<LoginLayoutProps> = ({children, isError, error, setIsError}) => {
    const navigate = useNavigate();

    useEffect(() => {
        const getData = async () => {
            const result = await loginCheck();
            localStorage.setItem('isLoggedIn', result.authenticated?.toString())
            const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';  
            if (isLoggedIn && result.authenticated) {
                localStorage.getItem("ai_access") === "astra" ? navigate("/AstraAIBot") : localStorage.getItem("ai_access") === "tvs" ? navigate("/TVSAIChatBot") : localStorage.getItem("ai_access") === "tvs2" ? navigate("/TVSAIChatBot2") : localStorage.getItem("ai_access") === "tvs3" ? navigate("/TVSAIChatBot3") : localStorage.getItem("ai_access") === "tvs4" ? navigate("/TVSAIChatBot4") : localStorage.getItem("ai_access") === "traningAI" ? navigate("/traningAI") : localStorage.getItem("ai_access") === "PmmAI" ? navigate("/PmmAI") : localStorage.getItem("ai_access") === "twai" ? navigate("/TwoWayAIChatBot") : localStorage.getItem("ai_access") === "sch" ? navigate("/SchneiderAI") :localStorage.getItem("ai_access") === "callai" ? navigate("/CallAI") :localStorage.getItem("ai_access") === "callai2" ? navigate("/V2CAI") : localStorage.getItem("ai_access") === "MauiXMaui" ? navigate("/MauiXMaui") : localStorage.getItem("ai_access") === "Drone" ? navigate("/Drone") : localStorage.getItem("ai_access") === "MauiXMaui-laptop" ? navigate("/MauiXMaui-laptop") : localStorage.getItem("ai_access") === "Maui4" ? navigate("/Maui4") : localStorage.getItem("ai_access") === "Avironix" ? navigate("/Avironix") : localStorage.getItem("ai_access") === "AvironixDashboard" ? navigate("/avironixDashboard") : navigate("/dashboard?page=1") 
                window.location.reload();
            }
        }
        getData();
    }, [navigate]);

    const handleDismiss = (alertId: string) => {
        const alertElement = document.getElementById(alertId);
        if (alertElement) {
            setIsError(false);
            alertElement.style.display = 'none';
        }
    };
    
    return(
        <div className="w-full h-full lg:flex">
            {isError &&
                <Alert
                    id="alert-2"
                    color="red"
                    iconColor="text-red-800 dark:text-red-400"
                    textColor="text-red-800 dark:text-red-400"
                    bgColor="bg-red-50 dark:bg-gray-800"
                    onDismiss={() => handleDismiss('alert-2')}
                >
                    {(error !== null &&  error !== "") ? error : "Some error happen"}
                </Alert>}
            <div className="w-full lg:w-1/2 lg:h-[100vh] bg-black flex justify-center items-center">
                <div className="flex justify-center items-center">
                    <img src={XoroWhite} className="w-[70%]" />
                </div>
            </div>
            <div className="w-full lg:w-1/2 lg:h-[100vh] mt-20 lg:mt-0 flex justify-center items-center">
                {children}
            </div>
        </div>
    );
}
export default LoginLayout;